export const contentUser = (closer: string) => {
  if (closer.startsWith('Torrin') && closer.endsWith('Winmill')) {
    return 'ALARM'
  }

  if (closer.startsWith('Alan') && closer.endsWith('Ferniza')) {
    return 'SOLAR'
  }

  return 'NORMAL'
}
